import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import { $Elements, Durations, Events } from './constants';
import { initLightboxes } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ----------Reviews Carousel ----------

	$('.reviews-slider-section .section-carousel').each(function() {
		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				autoplay: true,
				slidesPerView: 'auto',
				spaceBetween: 20,
				centeredSlides: true,
				initialSlide: 1,
				autoHeight: true,
				loop: false,
				observer: true,
				modules: [Navigation, Pagination, Autoplay],
				pagination: {
					el: this.querySelector('.swiper-pagination'),
					clickable: true,
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ----------Slider pages -  Carousel ----------

	$('.slider-page-section .section-carousel, .content-section .column-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				autoplay: true,
				slidesPerView: 'auto',
				spaceBetween: 20,
				centeredSlides: true,
				initialSlide: 1,
				loop: false,
				observer: true,
				modules: [Navigation, Pagination, Autoplay],
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},

				breakpoints: {
					1024: {
						slidesPerView: 'auto',
						centeredSlides: false,
						autoplay: false,
						spaceBetween: 0,
						allowTouchMove: false,
						simulateTouch: false,
					},
				}
			});
		}
	});

	// ---------- Lawyers Carousel ----------

	$('.lawyers-list-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				slidesPerView: 1.4,
				loop: false,
				spaceBetween: 16,
				autoplay: false,
				observer: true,
				modules: [Navigation, Pagination, Autoplay],
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},

				breakpoints: {
					1024: {
						slidesPerView: 4.2,
					},
				},
			});
		}
	});

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ----------- Target on infographic-------------
	$('.explanation-column .image, .text-article-section .infographie .image').each(function() {
		const imageSrc = this.getAttribute('src');

		// Add link for ligthbox
		const link = document.createElement('a');
		link.setAttribute('target', 'lightbox');
		link.setAttribute('href', imageSrc);
		link.setAttribute('rel', imageSrc);
		link.classList.add('link-glightbox');

		this.parentNode.insertBefore(link, this);
		link.appendChild(this);

		// Add button to similar larger view
		const button = document.createElement('button');
		button.setAttribute('type', 'button');
		button.textContent = 'Agrandir l’image';
		button.classList.add('larger-view-button');

		this.parentNode.appendChild(button);

		initLightboxes();
	});
});
